/*eslint camelcase: "error"*/

export const defaultConfig = {
    api: '',
    web: '',
    websocket: '',
    consoleLogLevel: 'warn',
    podName: '',
    podRegion: '',
    environment: '',
    sentry: {
        environment: 'local',
        dsn: 'https://35c30bb4524d84db0844ecc220dab76b@o448583.ingest.sentry.io/4506310270779392',
        logLevel: 'info',
        sampleRate: 0.1
    }
};

export type DefaultConfig = typeof defaultConfig;
